import { formValidateAndSend, getFormFields } from '../../../js/forms.js';

document.addEventListener(
	'DOMContentLoaded',
	function () {
        var depoimentoButton = document.querySelector('.form-depoimento .submit__form__button');
		var depoimentoForms = document.querySelector('.form-depoimento__form');
		const errorMessage = depoimentoForms.getAttribute('data-msg');
		const errorElement = document.querySelector('.form-depoimento .return_message.error_message');
		const successElement =  document.querySelector('.form-depoimento .return_message.success_message');
		const depoimentoFormsInputs = getFormFields('.form-depoimento__form', 'input');
		if(depoimentoButton){
			depoimentoButton.addEventListener('click', (e) => {
				e.preventDefault();
				formValidateAndSend(depoimentoForms, errorMessage, successElement, errorElement, "file", depoimentoButton, depoimentoFormsInputs) 
			})
		}

	},
	false
);
